
import * as Components from "./Twindragonxmas"

export default function getCustomComponent () {
  return Components
}

export function getShopId () {
  return "twindragonxmas"
}

